import { request } from "umi";
import { paramsSerializer } from "../api";

const urlPrefix = "/api/employees";

/**
 * Get Dispatch list
 *
 * GET api/jobs
 */
export async function getTenantEmployees(params: API.UserSearchParams) {
    return request<API.ResultArray<API.CurrentUser>>(`${urlPrefix}/get`, {
        method: "GET",
        params: {
            ...params,
        },
        withToken: true,
        paramsSerializer,
    }).then((res) => (res));
}

/**
 * True unless the employee was explicitly deactivated (users.is_active = 0).
 * Payloads without the flag are treated as active.
 */
export function isActiveEmployee(employee: { is_active?: number | boolean | null } | null | undefined): boolean {
    return !!employee && employee.is_active !== 0 && employee.is_active !== false;
}

/**
 * Get all tenant users (both tenant and employee types)
 *
 * GET api/users/get
 */
export async function getTenantUsers(params: API.UserSearchParams) {
    return request<API.ResultArray<API.CurrentUser>>("/api/users/get", {
        method: "GET",
        params: {
            ...params,
        },
        withToken: true,
        paramsSerializer,
    }).then((res) => (res));
}
